import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { FIELDS, SCHOOLS_BY_FIELD, fmt } from "@/data/vaseisFields";

export default function VaseisCard() {
  return (
    <section id="vaseis" data-testid="vaseis-card-section" className="py-20 md:py-32 bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Βάσεις 2026</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight flex items-center gap-3">
              <GraduationCap className="h-8 w-8" strokeWidth={1.5} /> Οι κορυφαίες σχολές κάθε πεδίου.
            </h2>
            <p className="mt-4 text-white/70 leading-relaxed">
              Τα μόρια του τελευταίου εισαγόμενου ανά Τμήμα (Πανελλαδικές 2026, ΓΕΛ 90%) — και υπολογιστής μορίων για να δεις ποιες σχολές «πιάνεις».
            </p>
          </div>
          <Link
            to="/vaseis"
            data-testid="vaseis-card-cta"
            className="group inline-flex items-center gap-2 shrink-0 bg-white text-primary font-mono-accent text-xs uppercase tracking-widest px-6 py-3.5 rounded-sm hover:bg-accent hover:text-white transition-colors"
          >
            Όλες οι βάσεις & υπολογιστής μορίων
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FIELDS.map((f, i) => {
            const Icon = f.icon;
            const top = SCHOOLS_BY_FIELD[f.id].slice(0, 3);
            return (
              <motion.div
                key={f.id}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                data-testid={`vaseis-card-field-${f.id}`}
                className="bg-white/5 border border-white/15 rounded-sm p-5 backdrop-blur-sm min-w-0 overflow-hidden"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-accent">{f.short}</span>
                  <Icon className="h-4 w-4 text-white/70" strokeWidth={1.5} />
                </div>
                <div className="font-heading font-bold text-sm leading-snug min-h-[2.5rem] text-white/90">{f.name}</div>
                <ol className="mt-4 border-t border-white/15 divide-y divide-white/10">
                  {top.map((s, j) => (
                    <li key={s.c} className="py-2.5 flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <a href={s.u} target="_blank" rel="noopener noreferrer" data-testid={`vaseis-card-school-${s.c}`} className="block text-xs font-medium leading-snug truncate hover:text-accent hover:underline" title={`${s.n} — Ιστοσελίδα Τμήματος`}>{j + 1}. {s.n}</a>
                        <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/50">{s.i}</div>
                      </div>
                      <span className="font-heading font-extrabold text-base whitespace-nowrap">{fmt(s.b)}</span>
                    </li>
                  ))}
                </ol>
                <Link to="/vaseis" data-testid={`vaseis-card-link-${f.id}`} className="mt-3 inline-flex items-center gap-1 font-mono-accent text-[10px] uppercase tracking-widest text-accent hover:text-white transition-colors">
                  Όλες οι {SCHOOLS_BY_FIELD[f.id].length} σχολές <ArrowRight className="h-3 w-3" />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
